import React from "react";
import Loading from "react-loading-spinkit";

const PageLoading = (props) => {
  return (
    <React.Fragment>
      {props.loading && (
        <div style={{ margin: "15% auto" }}>
          <Loading color="#9b59b6" show={props.loading} />
        </div>
      )}
    </React.Fragment>
  );
};

export default PageLoading;
